import { render } from "./ChooseSeatBack.vue?vue&type=template&id=117f37de"
import script from "./ChooseSeatBack.vue?vue&type=script&lang=js"
export * from "./ChooseSeatBack.vue?vue&type=script&lang=js"

import "./ChooseSeatBack.vue?vue&type=style&index=0&id=117f37de&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__